var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M81.452 50.203c.02-15.112-11.01-28.007-26.043-30.443-15.032-2.435-29.625 6.308-34.45 20.642C16.132 54.735 22.5 70.425 35.99 77.44a6.564 6.564 0 00-1.064 3.564v6.6c0 7.291 5.957 13.201 13.305 13.201h4.435c7.349 0 13.306-5.91 13.306-13.2v-6.6a6.563 6.563 0 00-1.065-3.565c10.178-5.335 16.545-15.818 16.544-27.238l.001.001zM59.276 81.005v2.2H48.188c-1.837 0-3.327 1.478-3.327 3.3 0 1.823 1.49 3.3 3.327 3.3h10.689a6.652 6.652 0 01-6.254 4.401h-4.435c-3.674 0-6.653-2.955-6.653-6.6v-6.6h17.74l.001-.001zm-8.87-6.6c-13.473 0-24.394-10.836-24.394-24.202C26.012 36.837 36.933 26 50.405 26c13.473 0 24.394 10.836 24.394 24.202a24.105 24.105 0 01-7.153 17.12 24.492 24.492 0 01-17.263 7.082h.022l.001.001z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M50.04 31.452a3.266 3.266 0 000 6.532c6.61.012 11.964 5.367 11.976 11.976a3.266 3.266 0 006.532 0c-.012-10.217-8.29-18.496-18.508-18.508z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.ee404f39.svg";
export { ForwardRef as ReactComponent };